import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=55210550&scoped=true&"
import script from "./revenue.vue?vue&type=script&lang=js&"
export * from "./revenue.vue?vue&type=script&lang=js&"
import style0 from "./revenue.vue?vue&type=style&index=0&id=55210550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55210550",
  null
  
)

export default component.exports